import { defineComponent as _defineComponent } from 'vue'
import { onBeforeMount, onMounted, ref, Ref } from 'vue';
import { useConfigStore } from '@/store';
import BannerList from '@/components/common/banner-list.vue';
import { ColumnLayout, ColumnType } from '@/types/banner-layout';
import { useStayTimebrow } from '@/components/area/mainland/recommend/hooks/use-staytime';
import { biBrow } from '@tencent/fit-bi-sdk';


export default /*#__PURE__*/_defineComponent({
  __name: 'city-strategy',
  setup(__props) {

const { getFilteredLayout } = useConfigStore();
// banner 列表
const columnLayoutList: Ref<ColumnLayout[] | null> = ref(null);

onBeforeMount(async () => {
  const bannerConfig = await getFilteredLayout([ColumnType.a, ColumnType.b, ColumnType.c]);
  if (bannerConfig) {
    columnLayoutList.value = bannerConfig;
  }
});
const observerElement: Ref<HTMLDivElement | null> = ref(null);
const biBrowAction = (timeInView: number) => {
  if (timeInView > 0) {
    biBrow('hot-merchant.staytime_brow', {
      fstaytime: timeInView,
    });
  }
};
useStayTimebrow(observerElement, biBrowAction);

onMounted(() => {
  if (observerElement.value) {
  }
});


return { __sfc: true,getFilteredLayout, columnLayoutList, observerElement, biBrowAction, BannerList }
}

})